const rules: string[] = [
  'iframe, .rr-block { background: #ccc }',
  'noscript { display: none !important; }',
];

export default rules;
